module.exports = __webpack_public_path__ + "img/icon_blank_default.539d3d5d.png";